module.exports = __webpack_public_path__ + "static/media/Kaufland logo.7ff5b6b1.png";